import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../../api/api';
import swal from 'sweetalert';
import logo from "../../assets/images/Logo smart farm1.jpg"
import Background from "../../assets/images/background-signup.png";

const NewPassValid = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [emailError, setEmailErr] = useState("");
  const [mdpError, setPassErr] = useState("");
  const [confMdpErr, setconfMdpErr] = useState("");
  const [errorMsg, setErrMsg] = useState(null)

  const [isValidatingToken, setIsValidatingToken] = useState(true);
  const [tokenValidPassword, setTknValidPass] = useState(false)

  const navigate = useNavigate()
  const params = useParams()
  let tokenToValid = params.ToValid

  useEffect(() => {
    const Validate = async () => {
      try {
        const res = await api.get(`/valid-forgot-password/${tokenToValid}`);
        if (res.data.type && res.data.type === "success") {
          setTknValidPass(true)
        }
        if (res.data.type && res.data.type === "danger") {
          setErrMsg("error_link_change_password")
        }
      } catch (e) {
        setErrMsg("error_link_change_password")
      } finally {
        setIsValidatingToken(false);
      }
    }
    Validate()
  }, [tokenToValid])

  const validate = () => {
    let emailError = '';
    let mdpError = '';
    let confMdpErr = '';

    if (!email) {
      emailError = t('email_cannot_be_blank', 'Email cannot be blank!');
    } else {
      const mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!mailformat.test(email)) {
        emailError = t('incorrect_email_format', 'Incorrect email format!');
      }
    }
    if (password.length < 6) {
      mdpError = t('password_min_length', 'Password cannot be less than 6 characters!');
    }
    if (password !== confirmPass) {
      confMdpErr = t('password_notmatch_validpassword', "Passwords don't match");
    }

    setEmailErr(emailError);
    setPassErr(mdpError);
    setconfMdpErr(confMdpErr);

    return !(emailError || mdpError || confMdpErr);
  };

  const handleSubmit = (event) => {
    event.preventDefault()
    if (validate()) {
      handleChangePass()
    }
  }

  const handleChangePass = () => {
    setIsSubmitting(true);
    const data = {
      tokenValidPassword: tokenToValid,
      email: email,
      password: password,
      confirmPassword: confirmPass
    }

    api.post('/change-password', data)
      .then(res => {
        if (res.data.type && res.data.type === "success") {
          swal({
            icon: 'success',
            title: t('ok'),
            text: res.data.message
          }).then(() => {
            resetForm();
            navigate('/');
          });
        }
        if (res.data.type && res.data.type === "danger") {
          setErrMsg("error_link_change_password");
        }
      })
      .catch(() => {
        setErrMsg("error_link_change_password");
      })
      .finally(() => {
        setIsSubmitting(false);
      })
  }

  const resetForm = () => {
    setEmail("");
    setPassword("");
    setConfirmPass("");
  }

  if (isValidatingToken) {
    return (
      <main className="auth-page auth-reset-page">
        <div className="auth-shell auth-shell-compact">
          <section className="auth-form-panel auth-status-panel">
            <div className="auth-form-content auth-reset-content auth-status-content">
              <i className="fas fa-circle-notch fa-spin auth-status-icon" aria-hidden="true" />
              <p>{t('checking_link', 'Vérification du lien en cours…')}</p>
            </div>
          </section>
        </div>
      </main>
    )
  }

  if (errorMsg) {
    return (
      <main className="auth-page auth-reset-page">
        <div className="auth-shell auth-shell-compact">
          <section className="auth-form-panel auth-status-panel">
            <div className="auth-form-content auth-reset-content auth-status-content">
              <span className="auth-status-icon auth-status-icon-danger">
                <i className="fas fa-exclamation-triangle" aria-hidden="true" />
              </span>
              <h2>{t('error_link_change_password', 'Ce lien de réinitialisation est invalide ou a expiré.')}</h2>
              <p>{t('request_new_link', 'Demandez un nouveau lien depuis la page de connexion.')}</p>
              <Link to="/" className="auth-primary-button auth-status-link">
                <i className="fas fa-arrow-left" />
                <span>{t('sign_in', 'Login')}</span>
              </Link>
            </div>
          </section>
        </div>
      </main>
    )
  }

  return (
    <main className="auth-page auth-reset-page">
      <div className="auth-shell auth-shell-compact">
        <section className="auth-visual" style={{ backgroundImage: `url(${Background})` }}>
          <div className="auth-visual-shade" />
          <Link to="/" className="auth-brand" aria-label="SmartFarm">
            <img src={logo} alt="SmartFarm" />
          </Link>
          <div className="auth-visual-content">
            <span className="auth-eyebrow">SMARTFARM</span>
            <h1>{t('change_password', 'Nouveau mot de passe')}</h1>
            <p>{t('choose_strong_password', 'Choisissez un mot de passe fort pour sécuriser votre compte.')}</p>
          </div>
          <div className="auth-visual-footer">
            <i className="fas fa-shield-alt" />
            <span>Accès sécurisé à votre exploitation</span>
          </div>
        </section>

        <section className="auth-form-panel">
          <div className="auth-form-topbar">
            <Link to="/" className="auth-back-link"><i className="fas fa-arrow-left" /> {t('sign_in', 'Login')}</Link>
          </div>

          <div className="auth-form-content auth-reset-content">
            <div className="auth-form-heading">
              <span className="auth-heading-icon"><i className="fas fa-lock" /></span>
              <div>
                <span className="auth-eyebrow">SMARTFARM</span>
                <h2>{t('change_password', 'Nouveau mot de passe')}</h2>
              </div>
            </div>

            <form className="auth-form" autoComplete="on" onSubmit={handleSubmit} noValidate>
              <label className="auth-field">
                <span>{t('email')}</span>
                <div className={`auth-input-wrap ${emailError ? "is-invalid" : ""}`}>
                  <i className="far fa-envelope" />
                  <input
                    type="email"
                    value={email}
                    placeholder="name@example.com"
                    autoComplete="email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {emailError && <small className="auth-field-error"><i className="fas fa-exclamation-circle" />{emailError}</small>}
              </label>

              <label className="auth-field">
                <span>{t('new_password', 'New password')}</span>
                <div className={`auth-input-wrap ${mdpError ? "is-invalid" : ""}`}>
                  <i className="fas fa-lock" />
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    placeholder="••••••••"
                    autoComplete="new-password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="auth-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? t('hide_password', 'Masquer le mot de passe') : t('show_password', 'Afficher le mot de passe')}
                  >
                    <i className={`far ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                  </button>
                </div>
                {mdpError && <small className="auth-field-error"><i className="fas fa-exclamation-circle" />{mdpError}</small>}
              </label>

              <label className="auth-field">
                <span>{t('confirm_new_password', 'Confirm the new password')}</span>
                <div className={`auth-input-wrap ${confMdpErr ? "is-invalid" : ""}`}>
                  <i className="fas fa-lock" />
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPass}
                    placeholder="••••••••"
                    autoComplete="new-password"
                    onChange={(e) => setConfirmPass(e.target.value)}
                  />
                  <button
                    type="button"
                    className="auth-password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    aria-label={showConfirmPassword ? t('hide_password', 'Masquer le mot de passe') : t('show_password', 'Afficher le mot de passe')}
                  >
                    <i className={`far ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`} />
                  </button>
                </div>
                {confMdpErr && <small className="auth-field-error"><i className="fas fa-exclamation-circle" />{confMdpErr}</small>}
              </label>

              <button type="submit" className="auth-primary-button" disabled={isSubmitting}>
                {isSubmitting ? <i className="fas fa-circle-notch fa-spin" /> : <i className="fas fa-check" />}
                <span>{t('submit', 'Submit')}</span>
              </button>
            </form>
          </div>
        </section>
      </div>
    </main>
  )
}

export default NewPassValid
